import { formatDateToDDMMYY } from 'utils/helpers/DateUtils'
import { applyMultipleFundReportPAITableHeaderStyles, formatData, getEmptyRows, mergeMultipleCellRanges, setRowHeight, textAlignCenter } from 'utils/helpers/ExcelUtils'
import { generatePrincipleMetricsRow, generateQuarterlySummaryRow, getAssetInformationTableHeaderShared, getPrincipleMetricsTableHeader, getQuarterlySummaryTableHeader, getfundReportSheetHeaderInformation } from './fundReportPAIExcelExport'

export const createFundReportPAIWasteSheet = (
  fundName,
  reportingYear,
  wasteBreakdown,
  assets,
  localize,
  selectedLanguage,
  excelSheet
) => {
  let excelDataArray = []
  excelDataArray.push(...getfundReportSheetHeaderInformation('t_waste_impact_report', fundName, reportingYear, localize))
  excelDataArray.push(...getEmptyRows(2))
  excelDataArray = getWasteQuarterlySummaryTable(excelDataArray, wasteBreakdown.quarterlySummary, reportingYear, localize)
  excelDataArray.push(...getEmptyRows(1))
  excelDataArray = getWastePrincipleMetricsTable(excelDataArray, wasteBreakdown.principleMetrics, reportingYear, localize)
  excelDataArray.push(...getEmptyRows(1))
  excelDataArray = getAssetInformationTable(excelDataArray, assets, reportingYear, localize, selectedLanguage, excelSheet)
  return excelDataArray
}

const getWasteQuarterlySummaryTable = (currentExcelData, quarterlySummaryData, reportingYear, localize) => {
  const {exposedValue, totalPortfolioValue, exposedValueShare} = quarterlySummaryData
  const data = [...currentExcelData]
  data.push(...getQuarterlySummaryTableHeader(localize, reportingYear))
  
  data.push(...[
    generateQuarterlySummaryRow('t_exposed_value', exposedValue.q1, exposedValue.q2, exposedValue.q3, exposedValue.q4, localize),
    generateQuarterlySummaryRow('t_total_portfolio_value', totalPortfolioValue.q1, totalPortfolioValue.q2, totalPortfolioValue.q3, totalPortfolioValue.q4, localize),
    generateQuarterlySummaryRow('t_exposed_value_share', exposedValueShare.q1, exposedValueShare.q2, exposedValueShare.q3, exposedValueShare.q4, localize)
  ])
  return data
}

const getWastePrincipleMetricsTable = (currentExcelData, principleMetricsData, reportingYear, localize) => {
  const data = [...currentExcelData]
  const {exposedValueShare} = principleMetricsData
  data.push(...getPrincipleMetricsTableHeader(localize, reportingYear))
  data.push(...[generatePrincipleMetricsRow('t_average_share_exposed_value', exposedValueShare.currentYear, exposedValueShare.previousYear, localize)])
  return data
}

const getAssetInformationTable = (currentExcelData, assetsArray, reportingYear, localize, selectedLanguage, excelSheet) => {
  const data = [...currentExcelData]
  data.push(...getAssetInformationTableHeaderShared(localize, reportingYear))
  assetsArray.forEach(asset => {
    const { 
      assetReference, 
      assetName, 
      constructionYear, 
      location,
      purchaseDate,
      saleDate, 
      gavPerQuarter,
      Waste
    } = asset
    data.push(...[{
      A: assetReference,
      B: assetName,
      C: location,
      D: formatDateToDDMMYY(purchaseDate, selectedLanguage),
      E: formatDateToDDMMYY(saleDate, selectedLanguage),
      F: constructionYear,
      G: formatData(gavPerQuarter.q1),
      H: formatData(gavPerQuarter.q2),
      I: formatData(gavPerQuarter.q3),
      J: formatData(gavPerQuarter.q4),
      K: formatData(Waste.exposed.q1, localize),
      L: formatData(Waste.exposed.q2, localize),
      M: formatData(Waste.exposed.q3, localize),
      N: formatData(Waste.exposed.q4, localize),
    }])
    excelSheet.row(data.length).height(31)
  })
  return data
}

export const applyStylingToWasteSheet = (excelSheet) => {
  excelSheet.usedRange().forEach(cell => {
    if(cell.address() === 'A8' || cell.address() === 'A14') {
      cell.style({topBorder: false})
    }

    if (cell.address() !== 'A1') {
      cell.style({fontSize: 12,  horizontalAlignment: 'left', verticalAlignment: 'center'})
    }
  })

  setRowHeight(excelSheet, 18, 30)
  mergeMultipleCellRanges(excelSheet, ['A18:A19', 'B18:B19', 'C18:C19', 'D18:D19', 'E18:E19', 'F18:F19', 'G18:J18', 'K18:N18'])
  applyMultipleFundReportPAITableHeaderStyles(['A18:N18', 'G19:N19', 'B8:E8', 'B14:C14'], excelSheet)
  textAlignCenter(excelSheet, 'G18:N18')
}